(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxSearchQueryConditionEnumReference', {
		bindings: {
			condition: '<',
			operators: '<',
		},
		controller: MxSearchQueryConditionEnumReferenceCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-search-query-condition/by-type/mx-search-query-condition-enum-reference.html',
	});

	MxSearchQueryConditionEnumReferenceCtrl.$inject = ['$scope', 'mx.shell.Config'];

	function MxSearchQueryConditionEnumReferenceCtrl($scope, mxConfig) {
		var vm = this;

		vm.enumerationValues = {};
		var watchers = [];
		var localEnumeration = [];
		var showHiddenValues = false;
		Object.defineProperty(vm, 'showHiddenValues', {
			get: function () {
				return showHiddenValues;
			},
			set: function (val) {
				showHiddenValues = val;
				filterItems();
			},
		});

		function filterItems() {
			vm.enumeration = localEnumeration.filter(function (item) {
				return vm.showHiddenValues || !item.hidden;
			});
		}

		vm.$onInit = function () {
			// TMP: have to convert to int type
			vm.condition.value = vm.condition.value.map(function (val) {
				return Number(val);
			});

			if (vm.condition.__enumeration) {
				vm.multiGroup = Object.keys(_.groupBy(vm.condition.__enumeration, 'Extentions.StateGroup')).length > 1;
				vm.showHiddenValuesInSearch = mxConfig.settings.dataSource.showHiddenValuesInSearch !== false;

				var hiddenExists = false;
				vm.condition.__enumeration.forEach(function (item) {
					var checked = vm.condition.value && vm.condition.value.length && vm.condition.value.indexOf(item.Value) !== -1;

					if (item.Hidden && !checked) {
						hiddenExists = true;
					}

					localEnumeration.push({
						title: item.DisplayString,
						value: item.Value,
						hidden: item.Hidden && !checked,
						checked: checked,
					});
					vm.enumerationValues[item.Value] = checked;
				});

				vm.showHiddenValuesInSearch = vm.showHiddenValuesInSearch && hiddenExists;
				filterItems();
			}
		};

		watchers.push(
			$scope.$watchCollection('vm.enumerationValues', function () {
				var value = [];

				Object.keys(vm.enumerationValues).forEach(function (status) {
					if (vm.enumerationValues[status]) {
						value.push(status);
					}
				});
				vm.condition.value = value;
			})
		);

		watchers.push($scope.$watch('vm.condition.value', updateConditionValidity));

		$scope.$on('$destroy', function () {
			watchers.forEach(function (w) {
				w();
			});
			watchers = [];
		});
		return vm;

		function updateConditionValidity() {
			var values = vm.condition.value;
			const withoutParamsMode = vm.condition.operator === vm.operators.IsNotSet.value || vm.condition.operator === vm.operators.IsSet.value;
			vm.condition.__valid = values.length > 0 || withoutParamsMode;
		}
	}
})();
